var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcRoundArrowBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.08 2.80732C11.0026 2.72972 10.9106 2.66815 10.8094 2.62614C10.7081 2.58412 10.5996 2.5625 10.49 2.5625C10.3804 2.5625 10.2719 2.58412 10.1706 2.62614C10.0694 2.66815 9.97741 2.72972 9.9 2.80732L4.36 8.34732C4.2982 8.409 4.24917 8.48226 4.21571 8.56291C4.18226 8.64356 4.16504 8.73001 4.16504 8.81732C4.16504 8.90464 4.18226 8.99109 4.21571 9.07174C4.24917 9.15239 4.2982 9.22565 4.36 9.28732L9.9 14.8273C10.2267 15.154 10.7533 15.154 11.08 14.8273C11.4067 14.5007 11.4067 13.974 11.08 13.6473L6.25334 8.81399L11.0867 3.98066C11.4067 3.66066 11.4067 3.12732 11.08 2.80732Z",
    fill: "url(#paint0_linear_5837_2895)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5837_2895",
    x1: 3.64614,
    y1: -0.647257,
    x2: 15.9816,
    y2: 12.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundArrowBack);
export default __webpack_public_path__ + "static/media/ic_round-arrow-back.166e86cac479d2fcf1f66aa1da124354.svg";
export { ForwardRef as ReactComponent };